import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import AvailabilityDetailActions from 'app/actions/AvailabilityDetailActions';

const AvailabilityDetailOverlayContainer = loadable(() =>
  import('app/components/shared/AvailabilityDetailOverlay/AvailabilityDetailOverlayContainer')
);

export function AvailabilityDetailsPageRoute() {
  return <AvailabilityDetailOverlayContainer disableClose />;
}

function getRouteData({ dispatch, params }) {
  return [
    dispatch(AvailabilityDetailActions.openAvailability(params.metadataId)),
    dispatch(AvailabilityDetailActions.getAvailability(params.metadataId))
  ];
}

export default connectRoute(AvailabilityDetailsPageRoute, { getRouteData });
